module.exports = __webpack_public_path__ + "static/media/Organization_6.c386148a.svg";